import React, { useEffect, useState } from "react";
import { Document, Page } from "react-pdf";
import {pdfjs} from "react-pdf";
import workerSrc from 'pdfjs-dist/build/pdf.worker.entry';
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

export default function PdfPreview(props){
  const { t } = useTranslation('pdf_preview');
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    setNumPages(null);
  }, [props.src]);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <div className="d-flex justify-content-center overflow-auto h-100">
      <Document
        file={props.src}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={<div className="text-white">t('on_error_msg')</div>}
        loading={<div className="text-white">{t('loading')}</div>}
      >
        {numPages &&
          Array.from(new Array(numPages), (el, index) => (
            <Page
              renderAnnotationLayer={false}
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              width={window.innerWidth * 0.7}
              height={window.innerHeight * 0.7}
            />
          ))}
      </Document>
    </div>

  );
}

PdfPreview.propTypes = {
  src: PropTypes.string.isRequired
}